// extracted by css-extract-rspack-plugin
export default {"dot":"_1d87f1a9","activeDot":"_8a4e65a5","medium":"_551828cb","small":"_492243a9","dark":"_9061c88a"};